// FETCH ALL FABRIC PO DETAILS
export const FETCH_FABRIC_PO_DETAILS_REQUEST_DK = 'FETCH_FABRIC_PO_DETAILS_REQUEST_DK';
export const FETCH_FABRIC_PO_DETAILS_SUCCESS_DK = 'FETCH_FABRIC_PO_DETAILS_SUCCESS_DK';
export const FETCH_FABRIC_PO_DETAILS_FAILURE_DK = 'FETCH_FABRIC_PO_DETAILS_FAILURE_DK';

// FETCH ALL FABRIC PO DETAILS
export const FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_REQUEST_DK = 'FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_REQUEST_DK';
export const FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_SUCCESS_DK = 'FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_SUCCESS_DK';
export const FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_FAILURE_DK = 'FETCH_FABRIC_PO_DETAILS_WITHOUT_ID_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_FABRIC_PO_DETAILS_GROUP_LIST_REQUEST_DK = 'FETCH_FABRIC_PO_DETAILS_GROUP_LIST_REQUEST_DK';
export const FETCH_FABRIC_PO_DETAILS_GROUP_LIST_SUCCESS_DK = 'FETCH_FABRIC_PO_DETAILS_GROUP_LIST_SUCCESS_DK';
export const FETCH_FABRIC_PO_DETAILS_GROUP_LIST_FAILURE_DK = 'FETCH_FABRIC_PO_DETAILS_GROUP_LIST_FAILURE_DK';

// CREATE FABRIC PO DETAILS
export const CREATE_FABRIC_PO_DETAILS_REQUEST_DK = 'CREATE_FABRIC_PO_DETAILS_REQUEST_DK';
export const CREATE_FABRIC_PO_DETAILS_SUCCESS_DK = 'CREATE_FABRIC_PO_DETAILS_SUCCESS_DK';
export const CREATE_FABRIC_PO_DETAILS_FAILURE_DK = 'CREATE_FABRIC_PO_DETAILS_FAILURE_DK';

// UPDATE FABRIC PO DETAILS
export const UPDATE_FABRIC_PO_DETAILS_REQUEST_DK = 'UPDATE_FABRIC_PO_DETAILS_REQUEST_DK';
export const UPDATE_FABRIC_PO_DETAILS_SUCCESS_DK = 'UPDATE_FABRIC_PO_DETAILS_SUCCESS_DK';
export const UPDATE_FABRIC_PO_DETAILS_FAILURE_DK = 'UPDATE_FABRIC_PO_DETAILS_FAILURE_DK';

// FETCH SINGLE STATE OF FABRIC PO DETAILS
export const FETCH_SINGLE_FABRIC_PO_DETAILS_REQUEST_DK = 'FETCH_SINGLE_FABRIC_PO_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_FABRIC_PO_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_FABRIC_PO_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_FABRIC_PO_DETAILS_FAILURE_DK = 'FETCH_SINGLE_FABRIC_PO_DETAILS_FAILURE_DK';

// DELETE FABRIC PO DETAILS
export const DELETE_FABRIC_PO_DETAILS_REQUEST_DK = 'DELETE_FABRIC_PO_DETAILS_REQUEST_DK';
export const DELETE_FABRIC_PO_DETAILS_SUCCESS_DK = 'DELETE_FABRIC_PO_DETAILS_SUCCESS_DK';
export const DELETE_FABRIC_PO_DETAILS_FAILURE_DK = 'DELETE_FABRIC_PO_DETAILS_FAILURE_DK';

export const RESET_FABRIC_PO_DETAILS_INFO_DK = 'RESET_FABRIC_PO_DETAILS_INFO_DK';

export const CREATE_FABRIC_PO_DETAILS_FORM_DK = 'CREATE_FABRIC_PO_DETAILS_FORM_DK';

export const UPDATE_FABRIC_PO_DETAILS_FORM_DK = 'UPDATE_FABRIC_PO_DETAILS_FORM_DK';

export const FETCH_FABRIC_PO_PREVIOUS_LIST_REQUEST_DK = 'FETCH_FABRIC_PO_PREVIOUS_LIST_REQUEST_DK';
export const FETCH_FABRIC_PO_PREVIOUS_LIST_SUCCESS_DK = 'FETCH_FABRIC_PO_PREVIOUS_LIST_SUCCESS_DK';
export const FETCH_FABRIC_PO_PREVIOUS_LIST_FAILURE_DK = 'FETCH_FABRIC_PO_PREVIOUS_LIST_FAILURE_DK';


export const FABRIC_CLOSE_BTN_POST_REQUEST = 'FABRIC_CLOSE_BTN_POST_REQUEST'
export const FABRIC_CLOSE_BTN_POST_SUCCESS = 'FABRIC_CLOSE_BTN_POST_SUCCESS'
export const FABRIC_CLOSE_BTN_POST_FALIURE = 'FABRIC_CLOSE_BTN_POST_FALIURE'



export const FABRIC_CHECK_ALL_UPDATE_REQUEST = 'FABRIC_CHECK_ALL_UPDATE_REQUEST'
export const FABRIC_CHECK_ALL_UPDATE_SUCCESS = 'FABRIC_CHECK_ALL_UPDATE_SUCCESS'
export const FABRIC_CHECK_ALL_UPDATE_FALIURE = 'FABRIC_CHECK_ALL_UPDATE_FALIURE'